// Expand/collapse icon for price-list cards: a plus that rotates into an X.
export default function PriceToggleIcon({ open }: { open: boolean }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden className="size-full">
      <circle
        cx="12"
        cy="12"
        r="12"
        className={`transition-colors duration-200 ${
          open ? "fill-purple-04" : "fill-purple-01"
        }`}
      />
      <g
        className={`origin-center transition-transform duration-200 ${
          open ? "rotate-45" : ""
        }`}
      >
        <path
          d="M12 7v10M7 12h10"
          className={`transition-colors duration-200 ${
            open ? "stroke-white" : "stroke-purple-03"
          }`}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
